import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { BagProvider } from "@/components/feature/bag/BagContext";
import { useEffect } from "react";
import { initSmoothScroll } from "@/lib/smoothScroll";
import "lenis/dist/lenis.css";

// Opacity-only entrance per route: no transforms, so the Hero's fixed pin is never broken
function RouteFade() {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="ff-page">
      <AppRoutes />
    </div>
  );
}

function App() {
  useEffect(() => initSmoothScroll(), []);
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <BagProvider>
          <RouteFade />
        </BagProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;